import { z } from "zod";

export const priceTotalsSchema = z.object({
    grossAmount: z.number(),
    netAmount: z.number(),
    valueAddedTax: z.number(),
    discountedGrossAmount: z.number().nullable(),
    discountedNetAmount: z.number().nullable(),
    discountedValueAddedTax: z.number().nullable(),
});

export const priceResponseSchema = z.object({
    getTotalPriceSunProtection: z.object({
        products: z.array(
            z.object({
                product: z.object({ id: z.coerce.string() }),
                sunProtectionProductId: z.string().nullable(),
                colorId: z.string().nullable(),
                total: priceTotalsSchema,
            }),
        ),
        productsTotals: priceTotalsSchema,
        productSurfaces: z.array(
            z.object({
                productId: z.coerce.string(),
                count: z.number(),
            }),
        ),
    }),
});
